module.exports = __webpack_public_path__ + "static/media/ga.8629ddf5.svg";